import React from 'react';
import { createComponent } from 'effector-react';
import TextLink from '@components/TextLink';
import { $libSelected, $libSelectedApi } from '../stores/libSelected';

const FooterClear = createComponent($libSelected, (_, selected) => (
  <div className="absolute right-0">
    <span>{`已勾选：${selected.length} 素材`}</span>
    <TextLink className="ml-10" onClick={() => $libSelectedApi.clear()}>
      清空
    </TextLink>
  </div>
));

export default FooterClear;
